module.exports = __webpack_public_path__ + "static/assets/f73022ee2d7ecaca2cb40cb539e126ab.png";